export default class Router
{
    /**
     * @param routes
     * @param route
     */
    constructor(routes) {
        this.routes = JSON.parse(routes);
    }

    /**
     * @param {string} hash
     */
    hash(hashname) {
        if (hashname.length > 0) {
            hashname = `#${hashname}`;
        }

        window.location.hash = hashname;
    }

    /**
     * @param {string} hash
     * @return {boolean}
     */
    hasHash(hash) {
        return window.location.hash.substr(1) === hash;
    }

    /**
     * @param routeName
     * @param args
     */
    postRedirect(routeName, args)
    {
        let action = this.routes[routeName].substr(1);
        let form = $('<form></form>');
        form.attr("method", "post");
        form.attr("action", action);

        $.each( args, function( key, value ) {
            var field = $('<input></input>');

            // Pass each arguments as hidden form fields
            field.attr("type", "hidden");
            field.attr("name", key);
            field.attr("value", value);

            form.append(field);
        });

        $(form).appendTo('body').submit();
    }

    /**
     * @param routeName
     * @return {string}
     */
    redirect(routeName, hash = '') {
        let protocol = window.location.protocol;
        let domain   = window.APP.config.domain;
        let appPath  = window.APP.config.appPath;
        routeName = this.routes[routeName].substr(1);

        if (hash.length > 0) {
            hash = `#${hash}`;
        }

        return window.location = `${protocol}//${domain}${appPath}/${routeName}${hash}`;
    }

    /**
     * @param pathname
     * @return {string}
     */
    findRouteByPathname(pathname) {
        for (let property in this.routes) {
            if (this.routes.hasOwnProperty(property)) {
                if (this.routes[property] === pathname) {
                    return property;
                }
            }
        }

        return 'index';
    }

    /**
     * @param url
     * @return {Element}
     * @docs https://gist.github.com/jlong/2428561
     */
    parseUrl(url) {
        let parser = document.createElement('a');
        parser.href = url.replace('/app_dev.php', '');

        return parser;
    }
}